import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class JunoService {
    constructor(private http: HttpClient) {
    }

    tokenizeCreditCard(storeId, hash, holderName, brand): any {
        debugger
        //type=0 = storeStatement, type=1 = userStatement
        var model = { storeId, hash, holderName, brand, type: 0 };
        return this.http.post(Configuration.apiUrl + 'Api/juno/tokenize', JSON.stringify(model), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    charge(seoUrl, statementId, paymentType, hash, paymentMethodId, last4number, holderName, brand, installment, newBillingInfo, billing): any {
        debugger
        var model = { statementId, paymentType, hash, last4number, holderName, paymentMethodId, brand, installment, newBillingInfo, billing };
        //console.log(JSON.stringify(model));
        return this.http.post(Configuration.apiUrl + 'Api/juno/charge?seoUrl=' + seoUrl, JSON.stringify(model), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    rollbackToBackup(statementId): any {
        console.log(Configuration.apiUrl + 'Api/Juno/RollbackToBackup?statementId=' + statementId);
        return this.http.get(Configuration.apiUrl + 'Api/Juno/RollbackToBackup?statementId=' + statementId)
    } 

    cancelOrRefund(statementId): any {
        console.log(Configuration.apiUrl + 'Api/Juno/CancelOrRefund?statementId=' + statementId);
        return this.http.get(Configuration.apiUrl + 'Api/Juno/CancelOrRefund?statementId=' + statementId)
    }

    updateJunoAccountStatus(friendlyUrl): any {
        return this.http.get(Configuration.apiUrl + 'Api/juno/UpdateJunoAccountStatus?ngoUrl=' + friendlyUrl)
    }

    getNgoAccount(friendlyUrl): any {
        return this.http.get(Configuration.apiUrl + 'Api/juno/GetNgoAccount?ngoUrl=' + friendlyUrl)
    }

    syncNgoAccount(friendlyUrl): any {
        return this.http.get(Configuration.apiUrl + 'Api/juno/SyncToNgoAccount?ngoUrl=' + friendlyUrl)
    }

    createNgoAccount(ngoUrl, forceAllDocuments): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/juno/createNgoAccount?ngoUrl=' + ngoUrl + '&forceAllDocuments=' + forceAllDocuments, null, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updateNgoAccount(ngoUrl): any {
        debugger
        return this.http.post(Configuration.apiUrl + 'Api/juno/updateNgoAccount?ngoUrl=' + ngoUrl, null, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

}